import React, { useCallback, useState } from 'react'
import $ from 'jquery'
import 'vendor/jquery.fullscreen.js'
import FontAwesome from 'react-fontawesome'


const FullscreenButton = () => {
  const
    elementToFillScreen = document.querySelector('#fullscreen'), // always the RoutedPageContainer

    [ iconName, setIconName ] = useState('expand'),
    [ title, setTitle ] = useState('View Fullscreen'),

    toggleFullscreen = useCallback(evt => {
      evt.preventDefault()

      if (!elementToFillScreen) { return }

      // call with null to fetch current fullscreen status
      const isFullscreen = $(elementToFillScreen).fullScreen(null)
      // call with opposite of current to toggle
      $(elementToFillScreen).fullScreen(!isFullscreen)

      // update the button as appropriate
      setIconName(isFullscreen ? 'expand' : 'compress')
      setTitle(isFullscreen ? 'View Fullscreen' : 'Exit Fullscreen')
    })

  // don't render if we didn't find an element to use
  return elementToFillScreen && (
    <button
      className='btn btn-round gray fullscreen-button'
      onClick={ toggleFullscreen }
      title={ title }
    >
      <FontAwesome name={ iconName } />
    </button>
  )
}

export default FullscreenButton
